import { FC } from "react";

interface BarcodeSVGProps {
    width?: number;
    height?: number;
}

const BarcodeSVG: FC<BarcodeSVGProps> = ({ width = "18px", height = "18px" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <g clip-path="url(#clip0_1192_8438)">
          <path d="M17.25 5H21V8.75" stroke="#9999A7" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.75 20H3V16.25" stroke="#9999A7" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21 16.25V20H17.25" stroke="#9999A7" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 8.75V5H6.75" stroke="#9999A7" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7.5 8.75V16.25" stroke="#9999A7" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16.5 8.75V16.25" stroke="#9999A7" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.5 8.75V16.25" stroke="#9999A7" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.5 8.75V16.25" stroke="#9999A7" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_1192_8438">
            <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
          </clipPath>
        </defs>
      </svg>
    );
};

export default BarcodeSVG;
